import { render } from "./CampaignCreation.vue?vue&type=template&id=2de63b05"
import script from "./CampaignCreation.vue?vue&type=script&lang=js"
export * from "./CampaignCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__